export default {"src":"/uk/_next/static/media/spot-thumb-up.2bd8f358.svg","height":50,"width":47,"blurWidth":0,"blurHeight":0};